import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoginService } from '../services/login.service';
import { User } from '../models/user';

@Injectable()
export class ProteansaasInterceptor implements HttpInterceptor {

  currentUser: User;

  constructor(
    private loginService: LoginService
  ) {
    this.loginService.currentUser.subscribe(x => this.currentUser = x);
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // ✅ If request body is FormData → DO NOT modify Content-Type
    if (request.body instanceof FormData) {
      const formDataRequest = request.clone({
        withCredentials: true
      });
      return next.handle(formDataRequest);
    }

    // ✅ Normal JSON requests
    const modifiedRequest = request.clone({
      setHeaders: {
        'Content-Type': 'application/json;charset=utf-8'
      },
      withCredentials: true
    });

    return next.handle(modifiedRequest);
  }

  // intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

  //   request = request.clone({
  //     setHeaders: {
  //       'Content-Type': 'application/json;charset=utf-8'
  //     },
  //     withCredentials: true
  //   });

  //   return next.handle(request);
  // }
}
